import axios from "axios"
import store from "@/store";

// 部署形态与 visitor-h5 一致：静态站点 + 同源 /api 反代到企业端后端（GoFrame，:9090）
// 因此 baseURL 固定为相对路径 /api，不再区分构建环境与域名。
const BASE_URL = "/api"

let http = axios.create({
    baseURL: BASE_URL,
    timeout: 10000
})

function getUserToken() {
    return store.state.token || ""
}

http.interceptors.request.use(function (config) {
    config.headers['authorization'] = getUserToken();
    return config;
}, function (error) {
    return Promise.reject(error);
});

http.interceptors.response.use(function (response) {
    // 后端约定 HTTP 恒为 200，业务码在 body.code：
    //   401 没有登录 / 402 token 过期或非法 —— 终端 token 失效时清空本地状态，
    //   跳回 /loading 重新走设备连接（输入设备码换取新的 TERMINAL token）。
    const data = response.data
    if (data && (data.code === 401 || data.code === 402)) {
        store.commit("clearTerminalSession")
        if (window.location.hash.indexOf("/loading") === -1) {
            window.location.hash = "#/loading"
        }
    }
    return response;
}, function (error) {
    return Promise.reject(error);
});

export const configJson = {
    headers: {
        'Content-Type': 'application/json'
    }
}

export const configForm = {
    headers: {
        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
    }
}

export const configMultipart = {
    headers: {
        'Content-Type': 'multipart/form-data'
    }
}

export let baseUrlManager = BASE_URL

export function getHttp() {
    return http
}

export default http
